module.exports = __webpack_public_path__ + "static/media/studio3-4.27768323.png";